// components/StripeDash.js
import React, { useEffect, useState } from "react";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { gql, useLazyQuery } from "@apollo/client";
import './StripeDash.css';


const GET_STRIPE_SESSION = gql`
  query GetStripeSession($merchPageId: ID!) {
    getStripeSession(merchPageId: $merchPageId)
  }
`;

export default function StripeDash({ merchPageId }) {
  const [connectInstance, setConnectInstance] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const stripePublicKey = "pk_live_51PQKUADMk9AEovmwLorxQT0i9q7H1veURQQbJVEyF2DxIiEGEE9iNjyyrjzokFcTIOIdZzDkGPwD2ITWuzZQLtMy00ZEgDAAaL";

  const [fetchSession, { called, loading, data, error }] = useLazyQuery(GET_STRIPE_SESSION, {
    variables: { merchPageId },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    fetchSession();
  }, [fetchSession]);

  useEffect(() => {
    if (data?.getStripeSession) {
      setClientSecret(data.getStripeSession);

      const instance = loadConnectAndInitialize({
        publishableKey: stripePublicKey,
        fetchClientSecret: () => Promise.resolve(data.getStripeSession),
        appearance: {
          variables: {
      colorPrimary: "#228403",
      colorBackground: '#1e1e1e',
      colorText: '#ffffff',
      colorTextSecondary: '#cccccc',
    },
        },
      });

      setConnectInstance(instance);
    }
  }, [data]);

  if (loading) return <p>Loading Stripe session...</p>;
  if (error) return <p>Error loading Stripe session: {error.message}</p>;
  if (!clientSecret) return null;

  return (
    <div className="container">
      <div className="banner">
        <h2>Stripe Dashboard</h2>
      </div>

      {connectInstance ? (
        <ConnectComponentsProvider connectInstance={connectInstance}>
          <ConnectAccountOnboarding clientSecret={clientSecret} />
        </ConnectComponentsProvider>
      ) : (
        <p>Initializing Stripe Connect...</p>
      )}
    </div>
  );
}
